export function selectRedShadow(invalid) {
    return {control: (provided) =>
        ({...provided, boxShadow: invalid ? "inherit" : "0 0 2px 4px rgba(255, 10, 10, 0.5)"})}
}

export function styleRedShadow(invalid) {
    return {boxShadow: invalid ? "inherit" : "0 0 2px 4px rgba(255, 10, 10, 0.5)"}
}